import enUS from './en-US';
import es from './es';
import enAU from './en-AU';

export const messages = {
  'en-US': enUS,
  es: es,
  'en-AU': enAU,
};
